/**
 * pdp-ingredients.js
 * Ingredient carousel — prev/next arrow navigation, section-scoped.
 * Uses CSS transform on the track element for smooth sliding.
 */
(function () {
  'use strict';

  function initIngredientSlider(sectionId) {
    var track    = document.getElementById('pdp-ingredients-track-' + sectionId);
    var viewport = document.getElementById('pdp-ingredients-viewport-' + sectionId);
    var btnPrev  = document.getElementById('pdp-ingredients-prev-' + sectionId);
    var btnNext  = document.getElementById('pdp-ingredients-next-' + sectionId);

    if (!track || !viewport || !btnPrev || !btnNext) return;

    var cards      = Array.from(track.children);
    var totalCards = cards.length;
    var currentIndex = 0;

    function getCardStep() {
      if (totalCards === 0) return 0;
      var card  = cards[0];
      var style = window.getComputedStyle(track);
      var gap   = parseFloat(style.columnGap) || 24;
      return card.offsetWidth + gap;
    }

    function getVisibleCount() {
      if (!viewport) return 1;
      var step = getCardStep();
      return step > 0 ? Math.floor(viewport.offsetWidth / step) : 1;
    }

    function getMaxIndex() {
      return Math.max(0, totalCards - getVisibleCount());
    }

    function updateSlider() {
      var step     = getCardStep();
      var maxIndex = getMaxIndex();
      if (currentIndex > maxIndex) currentIndex = maxIndex;
      track.style.transform = 'translateX(-' + (currentIndex * step) + 'px)';
      btnPrev.disabled = currentIndex <= 0;
      btnNext.disabled = currentIndex >= maxIndex;

      // Drive the gradient progress divider
      var section = track.closest('.pdp-ingredients');
      if (section) {
        var divider = section.querySelector('.pdp-ingredients__divider');
        if (divider) {
          var pct = maxIndex > 0 ? Math.round((currentIndex / maxIndex) * 100) : 100;
          divider.style.setProperty('--slider-progress', pct + '%');
        }
      }
    }

    btnPrev.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex -= 1;
        updateSlider();
      }
    });

    btnNext.addEventListener('click', function () {
      if (currentIndex < getMaxIndex()) {
        currentIndex += 1;
        updateSlider();
      }
    });

    // Re-calculate on window resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateSlider();
      }, 150);
    });

    updateSlider();
  }

  // Support multiple section instances on the same page
  document.querySelectorAll('[id^="pdp-ingredients-track-"]').forEach(function (el) {
    var sectionId = el.id.replace('pdp-ingredients-track-', '');
    initIngredientSlider(sectionId);
  });

  // Shopify theme editor live re-init
  document.addEventListener('shopify:section:load', function (e) {
    var track = e.target.querySelector('[id^="pdp-ingredients-track-"]');
    if (track) {
      var sectionId = track.id.replace('pdp-ingredients-track-', '');
      initIngredientSlider(sectionId);
    }
  });
})();
